"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
exports.WORD_ORDERED_LIST_SELECTOR = 'div.ListContainerWrapper > ul[class^="BulletListStyle"]';
/**
 * @internal
 */
exports.WORD_UNORDERED_LIST_SELECTOR = 'div.ListContainerWrapper > ol[class^="NumberListStyle"]';
/**
 * @internal
 */
exports.WORD_ONLINE_IDENTIFYING_SELECTOR = exports.WORD_ORDERED_LIST_SELECTOR + "," + exports.WORD_UNORDERED_LIST_SELECTOR;
/**
 * @internal
 */
exports.LIST_CONTAINER_ELEMENT_CLASS_NAME = 'ListContainerWrapper';
/**
 * @internal
 */
exports.UNORDERED_LIST_TAG_NAME = 'UL';
/**
 * @internal
 */
exports.ORDERED_LIST_TAG_NAME = 'OL';
var TEXT_CONTAINER_ELEMENT_CLASS_NAME = 'OutlineElement';
/**
 * @internal
 */
exports.WAC_IDENTIFING_SELECTOR = "ul[class^=\"BulletListStyle\"]>." + TEXT_CONTAINER_ELEMENT_CLASS_NAME + ",ol[class^=\"NumberListStyle\"]>." + TEXT_CONTAINER_ELEMENT_CLASS_NAME;
//# sourceMappingURL=constants.js.map